const Email = class Field {
    constructor() {
        this.subject = '';
        this.title = '';
        this.message = '';
    }
};

export default Email;
